import React, { useCallback, useRef, useEffect } from 'react'

import { useFormContext, useController } from 'react-hook-form'

import { TokenexProvider } from './tokenex-context'
import { useTokenex } from './use-tokenex'
import TokenexInput from './tokenex-input'

export type TokenexFieldProps = {
  id: string
  label: string
  type: 'ACH' | 'CC'
  dataId?: string
}

const TokenexField: React.FC<TokenexFieldProps> = ({ id, label, type }) => {
  const { control } = useFormContext()

  const { field } = useController({
    name: id,
    control,
  })

  // Store field functions in refs to avoid dependency issues
  const fieldRef = useRef(field)

  // Update ref when field changes
  useEffect(() => {
    fieldRef.current = field
  }, [field])

  // Stable callback handlers that don't depend on field
  const handleBlur = useCallback(() => {
    fieldRef.current.onBlur()
  }, [])

  const handleOnToken = useCallback((token: string) => {
    fieldRef.current.onChange(token)
  }, [])

  // Initialize tokenex with the required configuration
  const tokenex = useTokenex({
    id,
    type,
    label,
    onBlur: handleBlur,
    tokenizeOnBlur: true,
    onToken: handleOnToken,
  })

  return (
    <TokenexProvider tokenex={tokenex}>
      <TokenexInput id={id} />
    </TokenexProvider>
  )
}

export default TokenexField
